import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

/**
 * ExportButtons - Reusable export button group
 * 
 * @param {Function} onExportCSV - Callback for CSV export
 * @param {Function} onExportExcel - Callback for Excel export  
 * @param {Function} onExportPDF - Callback for PDF export (optional)
 * @param {boolean} showPDF - Whether to show PDF export button
 */
const ExportButtons = ({ onExportCSV, onExportExcel, onExportPDF, showPDF = false }) => {
  return (
    <div className="flex items-center gap-3">
      {onExportCSV && (
        <button
          onClick={onExportCSV}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
        >
          <ArrowDownTrayIcon className="w-4 h-4" />
          Export CSV
        </button>
      )}
      
      {onExportExcel && (
        <button
          onClick={onExportExcel}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
        >
          <ArrowDownTrayIcon className="w-4 h-4" />
          Export Excel
        </button>
      )}
      
      {showPDF && onExportPDF && (
        <button
          onClick={onExportPDF}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
        >
          <ArrowDownTrayIcon className="w-4 h-4" />
          Export PDF
        </button>
      )}
    </div>
  );
};

export default ExportButtons;
